/**
 * Target for the retired race-day routes (`/plans/event/:journeyId/race-day`,
 * `/race-day`) → the My Fuel timeline's `#race-day` anchor.
 *
 * Threads the `:journeyId` path param through as a `journey` query param so
 * MyFuel can SELECT that journey before scrolling — otherwise, with multiple
 * active journeys (valid per D1), the anchor scrolls to the first/default
 * journey's race-day card and an emailed/bookmarked link to a LATER race lands
 * on the WRONG journey (F-X1-3). Existing query params (utm_* — F-01-10) are
 * preserved. The `/race-day` route has no journeyId, so `journey` is omitted.
 */
export function buildRaceDayRedirect(
  journeyId: string | undefined,
  search: string
): { pathname: string; search: string; hash: string } {
  const params = new URLSearchParams(search);
  if (journeyId) params.set("journey", journeyId);
  const qs = params.toString();
  return { pathname: "/my-fuel", search: qs ? `?${qs}` : "", hash: "#race-day" };
}
